import { defineConfig as s, defineSlotRecipe as o, defineRecipe as r, mergeConfigs as c, createSystem as n, defaultConfig as g } from "@chakra-ui/react";
import { checkboxCardAnatomy as b, segmentGroupAnatomy as v, radioCardAnatomy as p, nativeSelectAnatomy as h, dialogAnatomy as _, checkboxAnatomy as m } from "@chakra-ui/react/anatomy";
import { useTheme as f, ThemeProvider as y } from "next-themes";
import { jsx as k } from "react/jsx-runtime";
const l = {
  river: "#005151",
  brandRed: "#8f0000",
  ink: "#231f20",
  rain: "#343e4e",
  alizarin: "#d62021",
  /** Darker river for hover/emphasis (replaces legacy blue mariner). */
  riverDeep: "#003d3d",
  plum: "#411c58",
  white: "#ffffff",
  black: "#000000",
  /** Tag borders / teal-tint UI (Grove `--tagButtonBorderColor`) */
  mist: "#bcdcd9",
  /** Grid / warm neutral border (Grove `--gridBorderColor`) */
  overcast: "#ede8d9",
  /** UI muted caption / tertiary label (Figma `--Colors-ui-textTertiary`; Grove theme `--uiTextTertiary`). */
  uiTextTertiary: "#656a75"
}, i = s({
  // Container-query conditions. Inert unless a component sets
  // `containerType: 'inline-size'` on an ancestor and uses `_cqMd` etc.
  // Thresholds are BLOCK widths (the element's own width), not the viewport.
  conditions: {
    cqSm: "@container (min-width: 360px)",
    cqMd: "@container (min-width: 480px)",
    cqLg: "@container (min-width: 600px)",
    cqXl: "@container (min-width: 768px)"
  },
  theme: {
    tokens: {
      colors: {
        // UI tokens - from Figma Shared-UI / app-specific UI needs
        // Figma: Colors/ui/btnHover
        uiBtnHover: { value: "#5b1002" },
        // Gray scale - from Figma Shared-UI
        gray: {
          50: { value: "#f4f4f3" },
          100: { value: "#d4d9df" },
          200: { value: "#E2E8F0" },
          // Figma border/default is #c4cad0; keep the hex at the palette level so semantic tokens can reference it.
          250: { value: "#c4cad0" },
          300: { value: "#b4bac1" },
          400: { value: "#99a1ab" },
          500: { value: "#8891a1" },
          600: { value: "#708191" },
          700: { value: "#587181" },
          800: { value: "#475a6d" },
          900: { value: l.rain },
          // intentional brand shift from generic #464c59 → Rain #343e4e
          950: { value: l.ink }
        },
        // Blue scale - from Figma Shared-UI (kuow-dark_blue)
        blue: {
          50: { value: "#e6f0f5" },
          100: { value: "#b8d4e1" },
          200: { value: "#8ab8cd" },
          300: { value: "#5c9cb9" },
          400: { value: "#2e80a5" },
          500: { value: "#043754" },
          600: { value: "#032d43" },
          700: { value: "#022332" },
          800: { value: "#011a22" },
          900: { value: "#011011" },
          950: { value: "#000808" }
        },
        // Teal scale - from Figma Shared-UI (kuow-aqua)
        teal: {
          50: { value: "#e2f3f3" },
          100: { value: "#c5e7e7" },
          200: { value: "#5bccce" },
          300: { value: "#4ab8ba" },
          400: { value: "#38a4a6" },
          500: { value: "#1a9ca8" },
          600: { value: "#158d98" },
          700: { value: "#117e88" },
          800: { value: "#0c6f78" },
          900: { value: "#032726" },
          950: { value: "#021716" }
        },
        // River - from Donation Form Figma (Front-End Theme primary action)
        river: {
          50: { value: "#f0f5f5" },
          100: { value: "#d9e5e5" },
          200: { value: "#b3cccc" },
          300: { value: "#99b9b9" },
          400: { value: "#668a8a" },
          500: { value: l.river },
          600: { value: "#004040" },
          700: { value: "#003333" },
          800: { value: "#002626" },
          900: { value: "#001a1a" },
          950: { value: "#000d0d" }
        },
        // Green scale - from Figma Shared-UI
        green: {
          50: { value: "#e6f9f3" },
          100: { value: "#b8f0e1" },
          200: { value: "#8ae7cf" },
          300: { value: "#5cdebd" },
          400: { value: "#2ed5ab" },
          500: { value: "#059267" },
          600: { value: "#04825a" },
          700: { value: "#03724d" },
          800: { value: "#026240" },
          900: { value: "#015233" },
          950: { value: "#014226" }
        },
        // Red scale - from Figma Shared-UI
        red: {
          50: { value: "#fef2f2" },
          100: { value: "#fee2e2" },
          200: { value: "#fecaca" },
          300: { value: "#fca5a5" },
          400: { value: "#f87171" },
          500: { value: l.alizarin },
          600: { value: "#b91c1c" },
          700: { value: "#991919" },
          800: { value: "#a41607" },
          900: { value: "#7f1d1d" },
          950: { value: "#450a0a" }
        },
        // Ceder - from Widgets Figma (Donation CTA Block)
        ceder: { value: l.brandRed },
        cederMuted: { value: "#d29999" },
        // Donation Form-specific backgrounds
        mist: { value: l.mist },
        overcast: { value: l.overcast },
        // Orange scale - from Figma Shared-UI
        orange: {
          50: { value: "#fff7ed" },
          100: { value: "#ffedd5" },
          200: { value: "#fed7aa" },
          300: { value: "#f3a297" },
          400: { value: "#ef8172" },
          500: { value: "#e45d50" },
          600: { value: "#d9453a" },
          700: { value: "#b73a30" },
          800: { value: "#952f26" },
          900: { value: "#73241c" },
          950: { value: "#511912" }
        },
        // Yellow scale - from Figma Shared-UI
        yellow: {
          50: { value: "#fefce8" },
          100: { value: "#fef9c3" },
          200: { value: "#fef08a" },
          300: { value: "#fde047" },
          400: { value: "#facc15" },
          500: { value: "#eab308" },
          600: { value: "#ca8a04" },
          700: { value: "#845209" },
          800: { value: "#713f12" },
          900: { value: "#422006" },
          950: { value: "#281304" }
        },
        // Pink scale - from Figma Shared-UI
        pink: {
          50: { value: "#fdf2f8" },
          100: { value: "#fce7f3" },
          200: { value: "#fbcfe8" },
          300: { value: "#f9a8d4" },
          400: { value: "#f472b6" },
          500: { value: "#ec4899" },
          600: { value: "#db2777" },
          700: { value: "#a41752" },
          800: { value: "#6d0e34" },
          900: { value: "#45061f" },
          950: { value: "#2c0514" }
        },
        // Purple scale - from Figma Shared-UI
        purple: {
          50: { value: "#faf5ff" },
          100: { value: "#f3e8ff" },
          200: { value: "#e9d5ff" },
          300: { value: "#d8b4fe" },
          400: { value: "#c084fc" },
          500: { value: "#a855f7" },
          600: { value: "#9333ea" },
          700: { value: "#641ba3" },
          800: { value: "#4a1772" },
          900: { value: "#2f0553" },
          950: { value: "#1a032e" }
        },
        // Cyan scale - from Figma Shared-UI
        cyan: {
          50: { value: "#ecfeff" },
          100: { value: "#cffafe" },
          200: { value: "#a5f3fc" },
          300: { value: "#67e8f9" },
          400: { value: "#22d3ee" },
          500: { value: "#06b6d4" },
          600: { value: "#0891b2" },
          700: { value: "#0c5c72" },
          800: { value: "#134152" },
          900: { value: "#072a38" },
          950: { value: "#051b24" }
        }
      },
      // "Outfit" leads: it is the real typeface name, the one Google Fonts and
      // Figma know, and the family `fonts.css` loads. Design tools read the first
      // family in the stack — lead with "Outfit Variable" and they ask Figma for a
      // font that does not exist there, and every import comes back Light.
      //
      // "Outfit Variable" trails only for consumers still loading
      // `@fontsource-variable/outfit` themselves (the sibling admin panels, until
      // they move to `@kuow/design-system/fonts.css`). Drop it once they have.
      fonts: {
        heading: { value: 'Outfit, "Outfit Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif' },
        body: { value: 'Outfit, "Outfit Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif' }
      },
      radii: {
        none: { value: "0" },
        xs: { value: "0.25rem" },
        // 4px
        sm: { value: "0.375rem" },
        // 6px (Figma l2)
        md: { value: "0.5rem" },
        // 8px
        lg: { value: "0.75rem" },
        // 12px
        xl: { value: "1rem" },
        // 16px
        "2xl": { value: "1.25rem" },
        // 20px
        "3xl": { value: "1.75rem" },
        // 28px
        full: { value: "9999px" }
      }
    },
    semanticTokens: {
      colors: {
        // Background tokens - from Figma Shared-UI semantic tokens
        bg: {
          DEFAULT: { value: { _light: "{colors.white}", _dark: "{colors.gray.950}" } },
          inverted: { value: { _light: "{colors.gray.950}", _dark: "{colors.white}" } },
          // #231f20
          subtle: { value: { _light: "{colors.gray.50}", _dark: "{colors.gray.900}" } },
          // #f4f4f3
          muted: { value: { _light: "{colors.gray.100}", _dark: "{colors.gray.800}" } },
          // #d4d9df
          emphasized: { value: { _light: "{colors.gray.250}", _dark: "{colors.gray.700}" } },
          // #c4cad0
          testing: { value: { _light: "{colors.pink.50}", _dark: "{colors.pink.900}" } },
          panel: { value: { _light: "{colors.white}", _dark: "{colors.gray.900}" } },
          mist: { value: { _light: "{colors.mist}", _dark: "{colors.gray.900}" } },
          overcast: { value: { _light: "{colors.overcast}", _dark: "{colors.gray.900}" } },
          error: { value: { _light: "{colors.red.50}", _dark: "{colors.red.950}" } },
          warning: { value: { _light: "{colors.orange.50}", _dark: "{colors.orange.950}" } },
          success: { value: { _light: "{colors.green.50}", _dark: "{colors.green.950}" } },
          info: { value: { _light: "{colors.blue.50}", _dark: "{colors.blue.950}" } }
        },
        // Foreground/text tokens - from Figma Shared-UI semantic tokens
        fg: {
          DEFAULT: { value: { _light: "{colors.gray.950}", _dark: "{colors.gray.50}" } },
          // #231f20
          inverted: { value: { _light: "{colors.gray.50}", _dark: "{colors.gray.950}" } },
          // #f4f4f3
          muted: { value: { _light: "{colors.gray.900}", _dark: "{colors.gray.200}" } },
          // Rain / gray.900
          subtle: { value: { _light: "{colors.gray.400}", _dark: "{colors.gray.400}" } },
          // #99a1ab
          error: { value: { _light: "{colors.red.500}", _dark: "{colors.red.300}" } },
          warning: { value: { _light: "{colors.yellow.600}", _dark: "{colors.yellow.300}" } },
          success: { value: { _light: "{colors.green.600}", _dark: "{colors.green.300}" } },
          info: { value: { _light: "{colors.blue.600}", _dark: "{colors.blue.200}" } }
        },
        // Alias: some apps use `text.*` tokens. Keep them aligned with `fg.*`.
        text: {
          DEFAULT: { value: { _light: "{colors.gray.950}", _dark: "{colors.gray.50}" } },
          inverted: { value: { _light: "{colors.gray.50}", _dark: "{colors.gray.950}" } },
          muted: { value: { _light: "{colors.gray.900}", _dark: "{colors.gray.200}" } },
          subtle: { value: { _light: "{colors.gray.400}", _dark: "{colors.gray.400}" } },
          error: { value: { _light: "{colors.red.500}", _dark: "{colors.red.300}" } },
          warning: { value: { _light: "{colors.yellow.600}", _dark: "{colors.yellow.300}" } },
          success: { value: { _light: "{colors.green.600}", _dark: "{colors.green.300}" } },
          info: { value: { _light: "{colors.blue.600}", _dark: "{colors.blue.200}" } }
        },
        // Border tokens - from Figma Shared-UI semantic tokens
        border: {
          DEFAULT: { value: { _light: "{colors.gray.250}", _dark: "{colors.gray.700}" } },
          // border/default from Figma
          subtle: { value: { _light: "{colors.gray.50}", _dark: "{colors.gray.900}" } },
          // #f4f4f3
          muted: { value: { _light: "{colors.gray.100}", _dark: "{colors.gray.800}" } },
          // #d4d9df
          emphasized: { value: { _light: "{colors.gray.300}", _dark: "{colors.gray.600}" } },
          // #b4bac1
          inverted: { value: { _light: "{colors.gray.800}", _dark: "{colors.gray.200}" } },
          // #475a6d
          error: { value: { _light: "{colors.red.500}", _dark: "{colors.red.300}" } },
          warning: { value: { _light: "{colors.orange.500}", _dark: "{colors.orange.300}" } },
          success: { value: { _light: "{colors.green.500}", _dark: "{colors.green.300}" } },
          info: { value: { _light: "{colors.blue.500}", _dark: "{colors.blue.200}" } }
        },
        // UI semantic tokens - from Figma Shared-UI
        "ui.btnHover": { value: "{colors.uiBtnHover}" },
        // #5b1002
        // Gray semantic tokens - from Figma Shared-UI
        "gray.solid": { value: { _light: "{colors.gray.900}", _dark: "{colors.gray.100}" } },
        // Rain / gray.900
        "gray.contrast": { value: { _light: "{colors.white}", _dark: "{colors.gray.950}" } },
        "gray.fg": { value: { _light: "{colors.gray.800}", _dark: "{colors.gray.200}" } },
        // #475a6d
        "gray.subtle": { value: { _light: "{colors.gray.100}", _dark: "{colors.gray.800}" } },
        // #d4d9df
        "gray.muted": { value: { _light: "{colors.gray.250}", _dark: "{colors.gray.700}" } },
        // From Figma
        "gray.emphasized": { value: { _light: "{colors.gray.300}", _dark: "{colors.gray.600}" } },
        // #b4bac1
        "gray.focusRing": { value: { _light: "{colors.gray.400}", _dark: "{colors.gray.400}" } },
        // #99a1ab
        // Red semantic tokens - from Figma Shared-UI
        "red.solid": { value: "{colors.red.600}" },
        // #b91c1c
        "red.contrast": { value: "{colors.white}" },
        "red.fg": { value: "{colors.red.700}" },
        // #991919
        "red.subtle": { value: "{colors.red.100}" },
        "red.muted": { value: "{colors.red.200}" },
        "red.emphasized": { value: "{colors.red.300}" },
        "red.focusRing": { value: "{colors.red.400}" },
        // Ceder semantic tokens - from Widgets Figma
        "ceder.solid": { value: "{colors.ceder}" },
        "ceder.muted": { value: "{colors.cederMuted}" },
        "ceder.emphasized": { value: "{colors.ceder}" },
        "ceder.contrast": { value: "{colors.white}" },
        "ceder.inverted": { value: "{colors.white}" },
        // Teal semantic tokens - from Figma Shared-UI
        "teal.solid": { value: "{colors.teal.600}" },
        // #158d98
        "teal.contrast": { value: "{colors.white}" },
        "teal.fg": { value: "{colors.teal.700}" },
        // #117e88
        "teal.subtle": { value: "{colors.teal.100}" },
        "teal.muted": { value: "{colors.teal.200}" },
        "teal.emphasized": { value: "{colors.teal.300}" },
        "teal.focusRing": { value: "{colors.teal.400}" },
        // River semantic tokens - from Donation Form Figma (Front-End Theme primary action)
        "river.solid": { value: "{colors.river.500}" },
        // #005151
        "river.contrast": { value: "{colors.white}" },
        "river.inverted": { value: "{colors.white}" },
        "river.fg": { value: "{colors.river.500}" },
        "river.subtle": { value: "{colors.river.50}" },
        "river.muted": { value: "{colors.river.300}" },
        // #99b9b9
        "river.emphasized": { value: "{colors.river.600}" },
        // #004040 - darker for hover states
        "river.focusRing": { value: "{colors.river.200}" },
        "river.border": { value: "{colors.river.500}" },
        // Blue semantic tokens - from Figma Shared-UI
        "blue.solid": { value: "{colors.blue.600}" },
        // #032d43
        "blue.contrast": { value: "{colors.white}" },
        "blue.fg": { value: "{colors.blue.700}" },
        // #022332
        "blue.subtle": { value: "{colors.blue.100}" },
        "blue.muted": { value: "{colors.blue.200}" },
        "blue.emphasized": { value: "{colors.blue.300}" },
        "blue.focusRing": { value: "{colors.blue.400}" },
        // Green semantic tokens - from Figma Shared-UI
        "green.solid": { value: "{colors.green.600}" },
        // #04825a
        "green.contrast": { value: "{colors.white}" },
        "green.fg": { value: "{colors.green.700}" },
        "green.subtle": { value: "{colors.green.100}" },
        "green.muted": { value: "{colors.green.200}" },
        "green.emphasized": { value: "{colors.green.300}" },
        "green.focusRing": { value: "{colors.green.400}" },
        // Orange semantic tokens - from Figma Shared-UI
        "orange.solid": { value: "{colors.orange.600}" },
        // #d9453a
        "orange.contrast": { value: "{colors.white}" },
        "orange.fg": { value: "{colors.orange.700}" },
        "orange.subtle": { value: "{colors.orange.100}" },
        "orange.muted": { value: "{colors.orange.200}" },
        "orange.emphasized": { value: "{colors.orange.300}" },
        "orange.focusRing": { value: "{colors.orange.400}" },
        // Yellow semantic tokens - from Figma Shared-UI
        "yellow.solid": { value: "{colors.yellow.300}" },
        // #fde047
        "yellow.contrast": { value: "{colors.black}" },
        "yellow.fg": { value: "{colors.yellow.800}" },
        "yellow.subtle": { value: "{colors.yellow.100}" },
        "yellow.muted": { value: "{colors.yellow.200}" },
        "yellow.emphasized": { value: "{colors.yellow.300}" },
        "yellow.focusRing": { value: "{colors.yellow.400}" },
        // Purple semantic tokens - from Figma Shared-UI
        "purple.solid": { value: "{colors.purple.600}" },
        // #9333ea
        "purple.contrast": { value: "{colors.white}" },
        "purple.fg": { value: "{colors.purple.700}" },
        "purple.subtle": { value: "{colors.purple.100}" },
        "purple.muted": { value: "{colors.purple.200}" },
        "purple.emphasized": { value: "{colors.purple.300}" },
        "purple.focusRing": { value: "{colors.purple.400}" },
        // Cyan semantic tokens - from Figma Shared-UI
        "cyan.solid": { value: "{colors.cyan.600}" },
        // #0891b2
        "cyan.contrast": { value: "{colors.white}" },
        "cyan.fg": { value: "{colors.cyan.700}" },
        "cyan.subtle": { value: "{colors.cyan.100}" },
        "cyan.muted": { value: "{colors.cyan.200}" },
        "cyan.emphasized": { value: "{colors.cyan.300}" },
        "cyan.focusRing": { value: "{colors.cyan.400}" }
      }
    },
    recipes: {
      donateButton: r({
        variants: {
          variant: {
            solid: {
              // Base theme: white background with gray border (matching Figma)
              bg: "bg",
              color: "fg",
              border: "1px solid",
              borderColor: "border",
              borderRadius: "sm",
              // 6px to match Figma
              _hover: {
                bg: "bg.subtle",
                borderColor: "border.emphasized"
              }
            }
          }
        }
      }),
      donateBlock: r({
        variants: {
          variant: {
            default: {
              bg: "bg.subtle",
              // Padding scales with the BLOCK width (container query), compact at base
              // so the block fits skinny columns; grows as the block widens.
              py: { base: "4", _cqMd: "7", _cqLg: "9" },
              px: { base: "3", _cqMd: "6", _cqLg: "9" },
              "& [data-part=root]": {
                bg: "transparent",
                borderWidth: "1px",
                borderColor: "border",
                borderRadius: "l2",
                boxShadow: "none"
              },
              "& [data-part=indicator]": {
                bg: "ceder.solid",
                borderRadius: "l2",
                boxShadow: "none"
              },
              "& [data-part=item]": {
                color: "gray.fg",
                cursor: "pointer",
                bg: "transparent",
                transition: "background-color 0.2s, border-color 0.2s, color 0.2s",
                "&:not([data-state=checked])": {
                  _hover: {
                    bg: "bg.muted"
                  }
                }
              },
              "& [data-part=item][data-state=checked]": {
                color: "red.contrast"
              },
              "& [data-donate-block-tier]": {
                bg: "transparent",
                color: "gray.fg",
                borderColor: "gray.muted",
                transition: "background-color 0.2s, border-color 0.2s, color 0.2s",
                _hover: {
                  bg: "bg.muted"
                },
                _active: {
                  bg: "bg.emphasized"
                }
              },
              '& [data-donate-block-tier][data-selected="true"]': {
                bg: "ceder.solid",
                color: "red.contrast",
                borderColor: "ceder.solid",
                _hover: {
                  bg: "ceder.solid",
                  borderColor: "ceder.solid"
                },
                _active: {
                  bg: "ceder.solid",
                  borderColor: "ceder.solid"
                }
              },
              "& [data-donate-block-cta]": {
                bg: "ceder.solid",
                color: "red.contrast",
                _hover: {
                  boxShadow: "sm"
                },
                _active: {
                  boxShadow: "none"
                }
              }
            },
            inverted: {
              bg: "ceder.solid",
              color: "red.contrast",
              py: { base: "4", _cqMd: "7", _cqLg: "9" },
              px: { base: "3", _cqMd: "6", _cqLg: "9" },
              "& [data-part=root]": {
                bg: "ceder.muted",
                borderWidth: "1px",
                borderColor: "ceder.solid",
                borderRadius: "l2",
                boxShadow: "none"
              },
              "& [data-part=indicator]": {
                bg: "bg",
                borderRadius: "l2",
                boxShadow: "none"
              },
              "& [data-part=item]": {
                color: "ceder.solid",
                cursor: "pointer",
                bg: "transparent",
                transition: "background-color 0.2s, border-color 0.2s, color 0.2s",
                "&:not([data-state=checked])": {
                  _hover: {
                    bg: "ceder.muted"
                  }
                }
              },
              "& [data-part=item][data-state=checked]": {
                color: "ceder.solid"
              },
              "& [data-donate-block-tier]": {
                bg: "transparent",
                color: "red.contrast",
                borderColor: "gray.muted",
                transition: "background-color 0.2s, border-color 0.2s, color 0.2s",
                _hover: {
                  bg: "ceder.muted"
                },
                _active: {
                  bg: "ceder.muted"
                }
              },
              '& [data-donate-block-tier][data-selected="true"]': {
                bg: "bg",
                color: "ceder.solid",
                borderColor: "bg",
                _hover: {
                  bg: "bg",
                  borderColor: "bg"
                },
                _active: {
                  bg: "bg",
                  borderColor: "bg"
                }
              },
              "& [data-donate-block-cta]": {
                bg: "bg",
                color: "ceder.solid",
                borderWidth: "1px",
                borderColor: "ceder.solid",
                _hover: {
                  bg: "ceder.solid",
                  color: "red.contrast",
                  borderColor: "red.contrast"
                },
                _active: {
                  bg: "ceder.solid",
                  color: "red.contrast",
                  borderColor: "red.contrast"
                }
              }
            }
          }
        }
      }),
      newsletterSignup: r({
        variants: {
          variant: {
            default: {
              bg: "bg.subtle",
              color: "fg",
              py: { base: "4", _cqMd: "7", _cqLg: "9" },
              px: { base: "3", _cqMd: "6", _cqLg: "9" },
              "& [data-newsletter-validation]": {
                color: "fg.error"
              },
              "& [data-newsletter-button]": {
                bg: "river.solid",
                color: "river.contrast",
                _hover: {
                  bg: "river.emphasized"
                }
              },
              "& [data-newsletter-input]": {
                bg: "white",
                borderColor: "gray.300"
              }
            },
            inverted: {
              bg: "gray.900",
              color: "white",
              py: { base: "4", _cqMd: "7", _cqLg: "9" },
              px: { base: "3", _cqMd: "6", _cqLg: "9" },
              "& [data-newsletter-validation]": {
                color: "fg.inverted"
              },
              "& [data-newsletter-button]": {
                bg: "white",
                color: "black",
                _hover: {
                  bg: "gray.50"
                }
              },
              "& [data-newsletter-input]": {
                bg: "gray.50",
                color: "fg",
                borderColor: "gray.700"
              }
            }
          }
        }
      }),
      checkboxCircle: r({
        base: {
          w: 7,
          h: 7,
          minW: 7,
          minH: 7,
          flexShrink: 0,
          borderRadius: "full",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1
        },
        variants: {
          isSelected: {
            true: {
              bg: "river.solid",
              color: "river.contrast",
              borderColor: "transparent"
            },
            false: {
              bg: "transparent",
              borderColor: "gray.muted"
            }
          }
        },
        defaultVariants: {
          isSelected: !1
        }
      })
    },
    slotRecipes: {
      checkboxCard: o({
        slots: b.keys(),
        base: {
          root: {
            borderRadius: "sm",
            // 6px to match Figma
            cursor: "pointer",
            _hover: {
              bg: "rgba(0, 0, 0, 0.02) !important"
            }
          }
        },
        variants: {
          colorPalette: {
            river: {
              root: {
                _checked: {
                  bg: "river.solid !important",
                  color: "river.contrast !important",
                  borderColor: "river.solid !important",
                  _hover: {
                    bg: "river.emphasized !important"
                  }
                },
                _hover: {
                  "&:not([data-state=checked])": {
                    bg: "rgba(0, 0, 0, 0.02) !important"
                  }
                }
              }
            }
          }
        }
      }),
      dataList: o({
        slots: ["root", "item", "itemLabel", "itemValue"],
        base: {
          root: {
            gap: "1.5",
            rowGap: "1.5"
          },
          item: {
            columnGap: "2",
            alignItems: "start"
          },
          itemLabel: {
            fontSize: "sm",
            lineHeight: "20px",
            alignSelf: "start"
          },
          itemValue: {
            fontSize: "sm",
            lineHeight: "20px",
            alignSelf: "start"
          }
        }
      })
    }
  }
});
function d(e) {
  const a = c(i, e);
  return n(g, a);
}
const x = {
  theme: {
    tokens: {
      // Explicitly set customer-facing typography so it diverges clearly from Hedy in Storybook.
      fonts: {
        heading: {
          value: 'Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
        },
        body: {
          value: 'Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
        }
      },
      lineHeights: {
        "4xl": { value: "1.1" }
      }
    },
    recipes: {
      button: r({
        base: {
          borderRadius: "sm",
          // 6px to match Figma
          cursor: "pointer",
          _disabled: {
            cursor: "not-allowed"
          }
        },
        variants: {
          colorPalette: {
            river: {
              bg: "river.solid !important",
              color: "river.contrast !important",
              _hover: {
                bg: "river.emphasized !important"
              },
              _disabled: {
                bg: "gray.300 !important",
                color: "white !important",
                opacity: 1,
                _hover: {
                  bg: "gray.300 !important"
                }
              }
            }
          }
        }
      }),
      donateButton: r({
        variants: {
          variant: {
            solid: {
              bg: "red.fg",
              color: "red.contrast",
              borderRadius: "sm",
              // 6px to match Figma
              _hover: {
                bg: "ui.btnHover",
                color: "red.contrast"
              }
            }
          }
        }
      }),
      input: r({
        base: {
          borderRadius: "sm"
          // 6px to match Figma
        }
      })
    },
    slotRecipes: {
      checkbox: o({
        slots: m.keys(),
        variants: {
          colorPalette: {
            river: {
              control: {
                _checked: {
                  bg: "river.solid",
                  borderColor: "river.solid"
                }
              },
              indicator: {
                color: "river.contrast"
              }
            }
          }
        },
        defaultVariants: {
          colorPalette: "river"
        }
      }),
      dialog: o({
        slots: _.keys(),
        base: {
          // Ensure dialogs have viewport gutters on mobile/tablet (per repo rules)
          positioner: {
            px: { base: "4", md: "6" },
            py: { base: "4", md: "8" }
          },
          closeTrigger: {
            cursor: "pointer",
            _hover: {
              opacity: 0.7
            }
          }
        }
      }),
      nativeSelect: o({
        slots: h.keys(),
        base: {
          field: {
            borderRadius: "sm"
            // 6px to match Figma
          }
        }
      }),
      radioCard: o({
        slots: p.keys(),
        base: {
          item: {
            borderRadius: "sm",
            // 6px to match Figma
            cursor: "pointer",
            _hover: {
              bg: "rgba(0, 0, 0, 0.02)"
            }
          }
        },
        variants: {
          size: {
            md: {
              item: {
                h: "12"
              },
              itemControl: {
                h: "12"
              }
            }
          },
          variant: {
            solid: {
              item: {
                bg: "bg",
                borderColor: "border",
                _checked: {
                  bg: "colorPalette.solid",
                  color: "colorPalette.contrast",
                  borderColor: "colorPalette.solid"
                },
                _hover: {
                  bg: "rgba(0, 0, 0, 0.02)",
                  _checked: {
                    bg: "colorPalette.emphasized"
                  }
                }
              }
            }
          },
          colorPalette: {
            river: {
              item: {
                _checked: {
                  bg: "river.solid !important",
                  color: "river.contrast !important",
                  borderColor: "river.solid !important"
                },
                _hover: {
                  bg: "rgba(0, 0, 0, 0.02) !important",
                  _checked: {
                    bg: "river.emphasized !important"
                  }
                }
              }
            }
          }
        }
      }),
      segmentGroup: o({
        slots: v.keys(),
        base: {
          root: {
            "--segment-radius": "radii.sm",
            // 6px to match Figma
            "--segment-indicator-shadow": "none",
            bg: "bg",
            boxShadow: "none",
            borderWidth: "1px",
            borderColor: "border"
          },
          item: {
            color: "gray.fg",
            cursor: "pointer",
            _hover: {
              bg: "rgba(0, 0, 0, 0.02)"
            }
          }
        },
        variants: {
          colorPalette: {
            river: {
              indicator: {
                bg: "river.solid !important"
                // Use indicator slot instead of CSS var
              },
              item: {
                "&[data-state=checked]": {
                  color: "river.contrast !important"
                },
                _hover: {
                  bg: "rgba(0, 0, 0, 0.02) !important"
                }
              },
              root: {
                "&:has([data-part=item][data-state=checked]:hover) [data-part=indicator]": {
                  bg: "river.emphasized !important"
                }
              }
            }
          }
        }
      })
    }
  },
  globalCss: {
    body: {
      bg: "bg",
      color: "text",
      transition: "background-color 0.2s, color 0.2s"
    }
  }
}, w = s(x), H = d(w), u = s({
  theme: {
    slotRecipes: {
      // One card in Hedy: a rounded, bordered surface that lifts off the page.
      // Chakra's stock card is border-only, so every card in the app was adding
      // `boxShadow="md"` by hand — and the ones that forgot read as flat panels
      // sitting next to lifted ones. The shadow belongs on the component, not on
      // each call site.
      //
      // Card is for a discrete surface on the page background. A panel INSIDE a
      // card or a form is a plain Box: stacking shadows just muddies both.
      card: o({
        slots: ["root", "header", "body", "footer", "title", "description"],
        base: {
          root: {
            // The whole surface, not just the lift: relying on Chakra's default
            // variant for the border meant any variant that drops it still
            // rendered a card that did not match the rest of Hedy.
            borderWidth: "1px",
            borderColor: "border",
            borderRadius: "l3",
            bg: "bg.panel",
            boxShadow: "md"
          }
        }
      }),
      status: o({
        slots: ["root", "indicator"],
        base: {
          root: {
            display: "inline-flex",
            alignItems: "center",
            w: "fit-content",
            borderWidth: "1px",
            borderColor: "colorPalette.solid",
            borderRadius: "sm"
          }
        },
        variants: {
          size: {
            sm: { root: { px: "2", py: "1" } },
            md: { root: { px: "3", py: "1.5" } },
            lg: { root: { px: "4", py: "2" } }
          }
        }
      }),
      table: o({
        slots: ["root", "header", "body", "row", "cell", "columnHeader", "caption", "footer"],
        base: {
          row: {
            _selected: {
              bg: "bg.subtle"
            }
          }
        },
        variants: {
          interactive: {
            true: {
              body: {
                "& tr": {
                  _hover: {
                    bg: "bg.subtle"
                  }
                }
              }
            }
          }
        }
      })
    },
    semanticTokens: {
      colors: {
        // Secondary text, matched to the Hedy Figma variables: `fg/muted` #708191
        // and `text/fg_subtle` #587181, which are already in the palette as
        // gray.600 / gray.700. The base theme points these at gray.900 / gray.400,
        // so they are overridden here rather than in base — the front-end theme
        // shares that base and keeps its own values.
        //
        // Note this inverts the usual Chakra ramp: in Hedy `subtle` is DARKER (more
        // emphasis) than `muted`. That is what the design file specifies.
        //
        // Dark mode is left as the base defines it; the Figma variables cover the
        // light theme only, so the two modes now order muted/subtle differently.
        "fg.muted": { value: { _light: "{colors.gray.600}", _dark: "{colors.gray.200}" } },
        "fg.subtle": { value: { _light: "{colors.gray.700}", _dark: "{colors.gray.400}" } },
        // `text.*` is an alias of `fg.*` in the base theme — keep them in step.
        "text.muted": { value: { _light: "{colors.gray.600}", _dark: "{colors.gray.200}" } },
        "text.subtle": { value: { _light: "{colors.gray.700}", _dark: "{colors.gray.400}" } },
        // Sidebar palette
        "bg.sidebar": { value: "{colors.black}" },
        "bg.sidebarActive": { value: "{colors.gray.900}" },
        "bg.sidebarHover": { value: "{colors.gray.900}" },
        "fg.sidebar": { value: "{colors.white}" },
        "bg.sidebarInput": { value: "{colors.gray.950}" },
        "fg.sidebarPlaceholder": { value: "{colors.gray.400}" },
        "fg.sidebarProfileName": { value: "{colors.gray.50}" },
        "fg.sidebarMuted": { value: "{colors.gray.700}" },
        "border.sidebarDivider": { value: "{colors.gray.900}" },
        "border.sidebarCollapse": { value: { _light: "{colors.gray.900}", _dark: "{colors.gray.900}" } },
        "fg.sidebarCollapseIconCollapsed": { value: { _light: "gray.fg", _dark: "{colors.white}" } },
        "border.sidebarFocus": { value: "{colors.whiteAlpha.800}" }
      }
    },
    recipes: {
      sidebarNavItem: r({
        base: {
          w: "100%",
          justifyContent: "flex-start",
          gap: "2",
          h: "10",
          py: "0",
          px: "4",
          textAlign: "left",
          borderRadius: "l2",
          bg: "transparent",
          color: "fg.sidebar",
          fontWeight: "semibold",
          fontSize: "sm",
          lineHeight: "20px",
          transition: "background-color 0.2s ease, padding 0.2s ease, gap 0.2s ease",
          _focus: {
            outline: "none"
          },
          _focusVisible: {
            outline: "2px solid",
            outlineColor: "border.sidebarFocus",
            outlineOffset: "-2px"
          },
          _expanded: {
            bg: "transparent"
          }
        },
        variants: {
          state: {
            inactive: {
              bg: "transparent",
              _hover: {
                bg: "bg.sidebarHover"
              },
              _focusVisible: {
                bg: "bg.sidebarHover"
              },
              _expanded: {
                bg: "transparent"
              }
            },
            active: {
              bg: "bg.sidebarActive",
              _hover: {
                bg: "bg.sidebarActive"
              },
              _focusVisible: {
                bg: "bg.sidebarActive"
              },
              _expanded: {
                bg: "bg.sidebarActive"
              }
            }
          },
          density: {
            main: {},
            sub: {
              h: "36px",
              fontWeight: "normal",
              px: "3.5",
              pl: "45px"
            }
          }
        },
        defaultVariants: {
          state: "inactive",
          density: "main"
        }
      }),
      topbarCrumbButton: r({
        base: {
          h: "9",
          minW: "9",
          px: "2",
          py: "0",
          gap: "1",
          borderRadius: "l2",
          justifyContent: "center",
          bg: "transparent",
          color: "gray.fg",
          fontWeight: "semibold",
          fontSize: "sm",
          lineHeight: "20px",
          _hover: {
            bg: "bg.subtle"
          },
          _focus: {
            outline: "none"
          },
          _focusVisible: {
            outline: "2px solid",
            outlineColor: "border",
            outlineOffset: "2px"
          }
        }
      }),
      button: r({
        base: {
          cursor: "pointer",
          _disabled: {
            cursor: "not-allowed"
          }
        },
        variants: {
          size: {
            // The design's small icon button (Figma 572:10623 / 621:2417): a 12px
            // glyph in 4px of padding, 20px square. Chakra's smallest built-in size
            // is `xs` at 32px, which reads as a control in its own right; these sit
            // inline beside a number or a name and have to stay quiet.
            "2xs": {
              h: "5",
              minW: "5",
              px: "1",
              gap: "0.5",
              textStyle: "2xs",
              borderRadius: "sm",
              _icon: { width: "3", height: "3" }
            }
          },
          variant: {
            outline: {
              borderColor: "border.muted"
            }
          },
          colorPalette: {
            river: {
              bg: "river.solid",
              color: "river.contrast",
              _hover: {
                bg: "river.emphasized",
                _disabled: {
                  bg: "river.solid"
                }
              }
            }
          }
        }
      }),
      donateButton: r({
        variants: {
          variant: {
            solid: {
              bg: "transparent",
              color: "teal.fg",
              border: "1px solid",
              borderColor: "teal.muted",
              borderRadius: "full",
              _hover: {
                bg: "teal.subtle",
                borderColor: "teal.emphasized"
              }
            }
          }
        }
      })
    }
  },
  globalCss: {
    body: {
      bg: "bg",
      color: "text",
      minWidth: "320px",
      transition: "background-color 0.2s, color 0.2s"
    }
  }
}), L = d(u);
function C() {
  const { resolvedTheme: e, setTheme: a, forcedTheme: t } = f();
  return {
    colorMode: t ?? e,
    setColorMode: a,
    toggleColorMode: () => {
      a(e === "dark" ? "light" : "dark");
    }
  };
}
function P(e, a) {
  const { colorMode: t } = C();
  return t === "dark" ? a : e;
}
function W(e) {
  return /* @__PURE__ */ k(
    y,
    {
      attribute: "class",
      defaultTheme: "system",
      enableSystem: !0,
      enableColorScheme: !0,
      disableTransitionOnChange: !0,
      ...e
    }
  );
}
const R = s({
  theme: {
    semanticTokens: {
      colors: {
        // ── Sidebar (always dark) ────────────────────────────
        "app.sidebar.bg": { value: { base: "{colors.black}", _dark: "{colors.black}" } },
        "app.sidebar.text": { value: { base: "{colors.white}", _dark: "{colors.white}" } },
        "app.sidebar.muted": { value: { base: "{colors.gray.700}", _dark: "{colors.gray.700}" } },
        "app.sidebar.hover": { value: { base: "{colors.gray.900}", _dark: "{colors.gray.900}" } },
        "app.sidebar.border": { value: { base: "{colors.gray.900}", _dark: "{colors.gray.900}" } },
        // ── Content ─────────────────────────────────────────
        "app.content.bg": { value: { base: "{colors.white}", _dark: "{colors.gray.950}" } },
        "app.border": { value: { base: "{colors.gray.250}", _dark: "#383838" } },
        "app.input.border": { value: { base: "{colors.gray.250}", _dark: "#555555" } },
        // ── Surfaces ─────────────────────────────────────────
        // Note: dark surface values (#252525, #2C2C2C, #262626) are approved design
        // values with no corresponding KUOW palette entry.
        "app.card.bg": { value: { base: "{colors.white}", _dark: "#252525" } },
        "app.card.shadow": {
          value: {
            base: "0 1px 3px rgba(0,0,0,0.06)",
            _dark: "0 1px 3px rgba(0,0,0,0.3)"
          }
        },
        "app.table.hover": { value: { base: "{colors.gray.50}", _dark: "#2C2C2C" } },
        "app.table.header": { value: { base: "{colors.gray.50}", _dark: "#262626" } },
        // ── Text ─────────────────────────────────────────────
        "app.text": { value: { base: "{colors.gray.950}", _dark: "{colors.gray.50}" } },
        "app.text.muted": { value: { base: "{colors.gray.700}", _dark: "{colors.gray.400}" } },
        // ── Interactive ──────────────────────────────────────
        // Note: #353535 dark hover value has no palette entry.
        "app.hover": { value: { base: "{colors.gray.50}", _dark: "#353535" } },
        "app.nav.active": { value: { base: "{colors.blue.500}", _dark: "{colors.blue.500}" } },
        "app.primary": { value: { base: "{colors.blue.500}", _dark: "{colors.blue.400}" } },
        // ── Status accents ───────────────────────────────────
        "app.status.pending": {
          value: { base: "{colors.yellow.400}", _dark: "{colors.yellow.400}" }
        },
        "app.status.escalated": { value: { base: "{colors.red.600}", _dark: "{colors.red.500}" } },
        "app.status.complete": {
          value: { base: "{colors.green.600}", _dark: "{colors.green.600}" }
        },
        // ── Badge variants ───────────────────────────────────
        // Note: #1E3A5F dark badge background has no palette entry (deep navy).
        "app.badge.used.bg": { value: { base: "{colors.blue.50}", _dark: "#1E3A5F" } },
        "app.badge.used.text": { value: { base: "{colors.blue.500}", _dark: "{colors.blue.200}" } },
        "app.badge.pending.bg": {
          value: { base: "{colors.yellow.100}", _dark: "{colors.yellow.900}" }
        },
        "app.badge.pending.text": {
          value: { base: "{colors.yellow.800}", _dark: "{colors.yellow.200}" }
        },
        "app.badge.muted.bg": { value: { base: "{colors.gray.50}", _dark: "{colors.gray.900}" } },
        "app.badge.muted.text": {
          value: { base: "{colors.gray.700}", _dark: "{colors.gray.400}" }
        },
        "app.badge.expired.bg": { value: { base: "{colors.red.100}", _dark: "{colors.red.950}" } },
        "app.badge.expired.text": {
          value: { base: "{colors.red.600}", _dark: "{colors.red.300}" }
        },
        "app.badge.success.bg": {
          value: { base: "{colors.green.100}", _dark: "{colors.green.900}" }
        },
        "app.badge.success.text": {
          value: { base: "{colors.green.600}", _dark: "{colors.green.200}" }
        },
        "app.badge.error.bg": { value: { base: "{colors.red.100}", _dark: "{colors.red.900}" } },
        "app.badge.error.text": {
          value: { base: "{colors.red.600}", _dark: "{colors.red.200}" }
        },
        // ── Story source ─────────────────────────────────────
        "app.source.omny": { value: { base: "{colors.purple.600}", _dark: "{colors.purple.600}" } },
        "app.source.cds": { value: { base: "{colors.blue.500}", _dark: "{colors.blue.500}" } },
        "app.source.test": { value: { base: "{colors.blue.500}", _dark: "{colors.blue.400}" } },
        // ── Error / alert ────────────────────────────────────
        "app.error.bg": { value: { base: "{colors.red.50}", _dark: "{colors.red.950}" } },
        "app.error.text": { value: { base: "{colors.red.600}", _dark: "{colors.red.300}" } },
        "app.error.fg": { value: { base: "{colors.red.500}", _dark: "{colors.red.400}" } },
        // ── Warning ──────────────────────────────────────────
        "app.warning.bg": {
          value: { base: "{colors.orange.50}", _dark: "{colors.orange.950}" }
        },
        "app.warning.border": {
          value: { base: "{colors.orange.200}", _dark: "{colors.orange.800}" }
        },
        "app.warning.text": {
          value: { base: "{colors.orange.900}", _dark: "{colors.orange.200}" }
        },
        // ── Trend indicators ─────────────────────────────────
        "app.trend.up": { value: { base: "{colors.green.600}", _dark: "{colors.green.400}" } },
        "app.trend.down": { value: { base: "{colors.red.500}", _dark: "{colors.red.400}" } },
        // ── Danger ───────────────────────────────────────────
        "app.danger": { value: { base: "{colors.red.600}", _dark: "{colors.red.500}" } }
      }
    }
  },
  globalCss: {
    'th, [role="columnheader"]': {
      fontWeight: "normal !important"
    }
  }
}), B = d(i);
function F(e) {
  const a = c(u, R), t = e ? c(a, e) : a;
  return d(t);
}
export {
  W as ColorModeProvider,
  l as KUOW_BRAND_COLORS,
  R as adminTokensConfig,
  B as baseTheme,
  i as baseThemeConfig,
  F as createAdminTheme,
  d as createTheme,
  w as frontEndConfig,
  x as frontEndConfigOverrides,
  H as frontEndTheme,
  u as hedyConfig,
  L as hedyTheme,
  C as useColorMode,
  P as useColorModeValue
};
